export const reportTranslationKeys: string[] = [
    'SELECTION',
    'DESCRIPTION',
    'COLOR',
    'EXPANDED',
    'GENERIC_NAME',
    'EXPORT_EXCEL',
    'SAVE',
    'SAVE_AS',
    'MULTI_PDF',
    'SEND_TO_PDF',
    'CANCEL',
    'SELECTED_REPORTS',
    'GENERATING',
    'REMOVE_REPORT',
    'REPORT_NOT_AVAILABLE'
  ];